import React from 'react'

import { Box, Color, Text } from '@gousto-internal/citrus-react'

import type { StandardRecipeItem } from '@library/api-menu-experience'

import { formatSurchargeLabel } from '../RecipeTile.utils'

type RecipeSurchargeProps = {
  recipe: StandardRecipeItem
  isOutOfStock: boolean
}

export const RecipeSurcharge = ({ recipe, isOutOfStock }: RecipeSurchargeProps) => {
  const surchargeLabel = formatSurchargeLabel(recipe.pricing?.perPortionSurcharge)

  if (!surchargeLabel || isOutOfStock) {
    return null
  }

  return (
    <Box data-testid="recipe-tile-surcharge" style={{ paddingTop: '0.5rem' }}>
      <Text size={2} color={Color.ColdGrey_800}>
        {surchargeLabel}
      </Text>
    </Box>
  )
}
